import { inject, Injectable } from '@angular/core';
import { ResourceService } from '../../shared/services/resource.service';
import { CreateUser, IUser, SignedUrl } from '@monorepo/interfaces';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserManagementService extends ResourceService<IUser, CreateUser, IUser> {
    private apiUrl = environment.apiConfig[1].uri;
    private httpClient = inject(HttpClient);

    constructor() {
        super('users');
    }

    public getUser(): Observable<IUser> {
        return this.httpClient
            .get<IUser>(`${this.apiUrl}/me`)
            .pipe(catchError(() => throwError(() => new Error('Error getting user'))));
    }

    public checkUserExists(oid: string): Observable<boolean> {
        return this.httpClient.get<IUser>(`${this.apiUrl}/users/${oid}`).pipe(
            map((user: IUser) => {
                return !!user;
            })
        );
    }

    public downloadUsers(params: HttpParams): Observable<SignedUrl> {
        return this.httpClient
            .get<SignedUrl>(`${this.apiUrl}/users/export/link`, { params })
            .pipe(catchError(() => throwError(() => new Error('Error downloading users'))));
    }
}
